module.exports = __webpack_public_path__ + "img/ColoredSpace4.79263c24.jpg";